// extracted by css-extract-rspack-plugin
export default {"row":"SeparatorRow_row__WLSZB","label":"SeparatorRow_label__P16WE","line":"SeparatorRow_line__AIp-a"};